module.exports = require("okta-i18n-bundles");